export default __webpack_public_path__ + "static/media/rx_dummy.55829ab3.jpeg";